module.exports = __webpack_public_path__ + "static/media/title_reservation.18da0d0c.jpg";